import Philosophy from "../../../../src/images/philosophy.jpeg";
import colors from '@undertheground/color';
import { Button } from '@undertheground/react';
import * as React from 'react';
export default {
  Philosophy,
  colors,
  Button,
  React
};